import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  path?: string; // route path, e.g. "/sanctuary"
  noindex?: boolean;
}

const BASE_URL = "https://therappi.lovable.app";

/**
 * Per-route head metadata. Inject once at the top of a page component.
 * Titles kept under 60 chars, descriptions under 160 chars.
 */
export const SEO = ({ title, description, path = "", noindex = false }: SEOProps) => {
  const url = `${BASE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
};

export default SEO;
